import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

// actions
import { tryToLogin } from '../actions'

// assets
import logoOvermedia from '../_assets/images/logo.png'

class Login extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      password: ''
    }
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handlePasswordChange = this.handlePasswordChange.bind(this)
  }
  handleEmailChange (e) {
    this.setState({email: e.target.value})
  }
  handlePasswordChange (e) {
    this.setState({password: e.target.value})
  }
  handleFormSubmit (e) {
    e.preventDefault()
    let user = {
      email: this.state.email,
      password: this.state.password
    }
    this.props.dispatch(tryToLogin(user))
  }
  render () {
    document.body.style.backgroundColor = '#474849'
    var error
    if (this.props.errorMessage !== '') {
      error = <span className='help-block'>{this.props.errorMessage}</span>
    }
    return (
      <div className='login-box panel'>
        <h1 className='login-box__title'>
          <img src={logoOvermedia} alt='Overmedia Logo' />
        </h1>

        <form onSubmit={this.handleFormSubmit}>
          <div className='form-group'>
            <label>E-mail:</label>
            <input className='form-control' type='text' name='email' value={this.state.email} onChange={this.handleEmailChange} />
          </div>
          <div className='form-group'>
            <label>Senha:</label>
            <input className='form-control' type='password' name='password' value={this.state.password} onChange={this.handlePasswordChange} />
          </div>
          <input className='btn btn-primary btn-md btn-block' type='submit' value={this.props.loginMessage} />

          {error}
        </form>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loginMessage: state.app.loginMessage,
    errorMessage: state.app.errorMessage
  }
}

Login.propTypes = {
  history: PropTypes.any,
  dispatch: PropTypes.func,
  errorMessage: PropTypes.string,
  loginMessage: PropTypes.string
}

export default connect(mapStateToProps)(Login)



// WEBPACK FOOTER //
// ./src/containers/Login.js